<template>
    <Main>
        <div slot="main" class="main user">
            <div class="bank_title">
                <Header :data='headerInfo'></Header>
                <div class="gobcak" @click="goBack"><i class="el-icon-arrow-left"></i><span>返回上一层</span></div>
            </div>
            <div class="content user_info">
                <div class="l">
                    <div class="subtitle">
                        <div class="subtitle_txt">
                            基础信息
                        </div>
                    </div>
                    <!-- <div class="user_info" v-if="dataInfo.basicInfo">
                        <p><label>养殖户姓名：</label><span>{{dataInfo.basicInfo.name}}</span></p>
                        <p><label>联系电话：</label><span>{{dataInfo.basicInfo.phone}}</span></p>
                        <p><label>养殖户类型：</label><span>{{dataInfo.basicInfo.farmerType}}</span></p>
                        <p><label>养殖方式：</label><span>{{dataInfo.basicInfo.farmMode}}</span></p>
                        <p><label>畜牧科技师：</label><span>{{dataInfo.basicInfo.specialist}}</span></p>
                        <p><label>所在区域：</label><span>{{dataInfo.basicInfo.area}}</span></p>
                    </div> -->
                    <div class="user_info" v-if="basicsInfo">
                        <p><label>养殖户姓名：</label><span>{{ basicsInfo.farmerName }}</span></p>
                        <p><label>联系电话：</label><span>{{ basicsInfo.phone }}</span></p>
                        <p><label>养殖户类型：</label><span>{{ basicsInfo.farmerType }}</span></p>
                        <p><label>养殖方式：</label><span>{{ basicsInfo.breedingMethod }}</span></p>
                        <p><label>畜牧科技师：</label><span>{{ basicsInfo.rearLiveStock }}</span></p>
                        <p><label>所在区域：</label><span>{{ basicsInfo.address }}</span></p>
                    </div>
                    <div class="subtitle">
                        <div class="subtitle_txt">
                            养殖信息
                        </div>
                    </div>
                    <div class="total_data" v-if="breedList">
                        <div class="total_data_item">
                            <img src="../../assets/data_icon_001.png" alt="">
                            <div>
                                <label>存栏活畜数量：</label>
                                <span>{{ breedList.liveStockQuantity }}<i>头</i></span>
                            </div>
                        </div>
                        <div class="total_data_item">
                            <img src="../../assets/data_icon_001.png" alt="">
                            <div>
                                <label>当前监管数量：</label>
                                <span>{{ breedList.superviseQuantity }}<i>头</i></span>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="chart_title">存栏活畜品种分布</div>
                    <div class="rang_box">
                        <div class="chart_rang" id='chartRang1'></div>
                    </div> -->
                    <div class="chart_title mt-sm">存栏活畜品种分类分布</div>
                    <div class="rang_box">
                        <div class="chart_rang" id='chartRang2'></div>
                    </div>
                </div>
                <div class="c">
                    <div class="subtitle">
                        <div class="subtitle_txt">
                            活畜列表
                        </div>
                    </div>
                    <div class="table">
                        <!-- <el-table ref='table' :data="tableData" max-height="10.5rem" :row-style="{ height: '5px'}"
                            :cell-style="{ padding: '0' }" align="center" header-align="center"
                            :row-class-name="tableRowClassName" @row-click='rowClick' :destroy-on-close="true">
                            <el-table-column show-overflow-tooltip align="center" property="serialNum" width="100"
                                label="耳标编码"></el-table-column>
                            <el-table-column show-overflow-tooltip align="center" property="animalKind" width="80"
                                label="活畜品种"></el-table-column>
                            <el-table-column show-overflow-tooltip align="center" property="monthAge" width="80"
                                label="月龄(月)"></el-table-column>
                            <el-table-column show-overflow-tooltip align="center" property="birthday" width="100"
                                label="出生日期"></el-table-column>
                            <el-table-column show-overflow-tooltip align="center" property="liveNess" width="80"
                                label="活跃度"></el-table-column>
                            <el-table-column show-overflow-tooltip align="center" property="todayNumber" width="120"
                                label="今日运动量(步)"></el-table-column>
                            <el-table-column show-overflow-tooltip align="center" property="heartRate" width="80"
                                label="当前心率"></el-table-column>
                            <el-table-column show-overflow-tooltip align="center" property="animalHeat" width="80"
                                label="当前体温"></el-table-column>
                            <el-table-column show-overflow-tooltip align="center" width="70" label="操作">
                                <template slot-scope="scope">
                                    <i class="operation el-icon-more" @click.stop="detail(scope.row)"></i>
                                </template>
                            </el-table-column>
                        </el-table> -->
                        <el-table ref='table' :data="liveStockList" max-height="10.5rem" :row-style="{ height: '5px' }"
                            :cell-style="{ padding: '0' }" align="center" header-align="center"
                            :row-class-name="tableRowClassName" @row-click='rowClick' :destroy-on-close="true">
                            <el-table-column show-overflow-tooltip align="center" property="theEarEncipher" width="100"
                                label="耳标编码">
                            </el-table-column>
                            <el-table-column show-overflow-tooltip property="liveVariety" width="80" label="活畜品种">
                            </el-table-column>
                            <el-table-column show-overflow-tooltip align="center" property="monthAge" width="80"
                                label="月龄(月)">
                            </el-table-column>
                            <el-table-column show-overflow-tooltip align="center" property="birth" width="100"
                                label="出生日期">
                            </el-table-column>
                            <el-table-column show-overflow-tooltip align="center" property="liveness" width="80"
                                label="活跃度"></el-table-column>
                            <el-table-column show-overflow-tooltip align="center" property="todayStepNumber" width="120"
                                label="今日运动量(步)">
                            </el-table-column>
                            <el-table-column show-overflow-tooltip align="center" property="heartRate" width="80"
                                label="当前心率">
                            </el-table-column>
                            <el-table-column show-overflow-tooltip align="center" property="animal_heat" width="80"
                                label="当前体温">
                            </el-table-column>
                            <el-table-column show-overflow-tooltip align="center" width="70" label="操作">
                                <template slot-scope="scope">
                                    <i class="operation el-icon-more" @click.stop="detail(scope.row)"></i>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="pagination">
                            <!-- <el-pagination
                                small
                                layout="prev, pager, next"
                                :total="50">
                            </el-pagination> -->
                        </div>
                    </div>
                </div>
                <div class="r">
                    <div class="subtitle">
                        <div class="subtitle_txt">
                            实时监控
                        </div>
                        <el-dropdown @command="selectLive" trigger="click">
                            <span class="el-dropdown-link">
                                {{ currentDeviceInfo.mountLocation || '切换视频' }}<i
                                    class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu style="border: none!important;" slot="dropdown">
                                <el-dropdown-item v-for="(item, index) in deviceList" :key="index" :command='item'>
                                    {{ item.mountLocation }}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="device_main">
                        <div class="device_box" ref="device_box">
                            <div id="myPlayer" v-if="currentDeviceInfo.deviceType == 3"></div>
                            <video v-else autoplay controls width="100%" height="100%" muted id="myVideo"></video>
                            <!-- <video src="../../assets/login-bg.mp4" width="100%" height="100%" autoplay="autoplay" loop class="fillWidth" muted='muted'>
                            </video> -->
                            <div class="empty" v-if="camerasList.length === 0">
                                <!-- <img src="../../assets/camera_empty.png" alt="" srcset="" /> -->
                                <!-- <p>暂无视频设备</p> -->
                            </div>
                        </div>
                        <!-- <img v-if="camerasList.length != 0" src="../../assets/zoom_icon.png" class="zoom_icon" @click.stop="enlarge" /> -->
                    </div>
                    <div class="subtitle">
                        <div class="subtitle_txt">
                            牧场空间概览
                        </div>
                    </div>
                    <div class="space_data" v-if="grazingSpaceOverview">
                        <div class="space_data_item">
                            <img src="../../assets/data_icon_001.png" alt="">
                            <span>气温：{{ grazingSpaceOverview.airTemperature }}</span>
                        </div>
                        <div class="space_data_item">
                            <img src="../../assets/data_icon_001.png" alt="">
                            <span>湿温：{{ grazingSpaceOverview.dampWarm }}</span>
                        </div>
                        <div class="space_data_item">
                            <img src="../../assets/data_icon_001.png" alt="">
                            <span>气压：{{ grazingSpaceOverview.airPressure }}</span>
                        </div>
                        <div class="space_data_item">
                            <img src="../../assets/data_icon_001.png" alt="">
                            <span>海拔：{{ grazingSpaceOverview.elevation }}</span>
                        </div>
                    </div>
                    <div class="map_box">
                        <div id="map" class="map_main"></div>
                    </div>
                </div>
            </div>
            <NetworkModel ref="NetworkModel"></NetworkModel>
        </div>
    </Main>
</template>
<script type="text/javascript" src="https://api.map.baidu.com/api?v=2.0&ak=BnKBCnnQGMGiSnEmjgRyhXZRG4MV2YuS"></script>
<script>
import Main from "@/components/main.vue";
import Header from "../../components/header.vue";
// import BMap from 'BMap'
// import flvjs from "flv.js";
import NetworkModel from "@/views/netWorkModel/index.vue"
export default {
    components: {
        Main,
        Header,
        NetworkModel
    },
    data() {
        return {
            headerInfo: {},
            userInfo: {},
            dataInfo: {},
            tableData: [],
            camerasList: [],
            decoder: {},
            camerasListItem: {},
            map: {},
            point1: {},
            polygon2: {},
            anType: '',
            carMk: {},
            myIcon2: {},
            path: [],
            deviceList: [],
            currentDeviceInfo: {},
            flvPlayer: null,
            // 基础信息
            basicsInfo:{},
            // 活畜列表
            liveStockList:[],
            // 图表养殖信息
            breedList:{},
            // 存栏活畜品种分类分布信息
            kindTypeDis:[],
            // 牧场空间信息
            grazingSpaceOverview:{},
            // 电子围栏信息
            enclosurelist:{}

        };
    },
    created() {
        this.headerInfo = {
            name: window.localStorage.getItem('screenName')
        }
        this.userInfo = JSON.parse(window.localStorage.getItem('NMYDATAUSERINFO'))
        // this.dataInfo = JSON.parse(window.localStorage.getItem('userInfoItem')).detail
        // this.tableData = this.dataInfo.liveAnimalList.list
        // this.getData()
        this.basicsInfo=JSON.parse(window.localStorage.getItem('userInfoItem'))
        this.getDeviceList()
        // 查询活畜列表
         this.getLiveStockList()
        //  牧场空间查询列表
        this.getPastureList()
        // 养殖信息查询列表
        this.getbreedList()
        // 存栏活畜品种分类查询
        this.getVarietiesList()
    },
    mounted() {
        // this.dataInfo.animalKindDis.forEach((item) => {
        //     item.name = item.kind;
        //     item.value = item.quantity;
        // })
        // this.dataInfo.kindTypeDis.forEach((item) => {
        //     item.name = item.type;
        //     item.value = item.quantity;
        // })
        // this.rangChart({
        //     dom: 'chartRang1',
        //     data: this.dataInfo.animalKindDis
        // })
        // this.rangChart({
        //     dom: 'chartRang2',
        //     data: this.dataInfo.kindTypeDis
        // })
      
        // this.path = this.tableData[0].interspaceOverview.JsonDataLine
        // this.anType = this.tableData[0].interspaceOverview.JsonDataLine[0].type
        // this.infoMap(this.tableData[0].interspaceOverview.JsonDataRail)
    },
    methods: {
        //  电子围栏查询
        enclosureList(row){
            this.$http({
                url:'screenapp-service/screenElectronicFence/select',
                method: 'post',
                data: {
                    animalId: '1'
                    // animalId: row.animalId
                },
            }).then(res => {
                 const data = res.data;
                    if(data.code === 200) {
                 this.path = data.result
                 this.anType = data.result[0].type
                 this.infoMap(data.result)
                    } else {
                    // this.$message.error(data.message);
                }
            })
        },
         // 查询活畜列表
         getLiveStockList(){
         this.$http({
                url:'screenapp-service/screenLiveStock/listLiveStock',
                method: 'post',
                data: {
                    "farmerId": this.basicsInfo.farmerId
                },
            }).then(res => {
                 const data = res.data;
                    if(data.code === 200) {
                  this.liveStockList= data.result
                   // 电子围栏查询
                 this.enclosureList(this.liveStockList[0])
                    } else {
                    // this.$message.error(data.message);
                }
            })
         },     
          //  牧场空间查询列表
        getPastureList() {
        this.$http({
                url:'screenapp-service/screenGrazingSpace/list',
                method: 'post',
                data: {
                    "farmerId": this.basicsInfo.farmerId
                },
            }).then(res => {
                 const data = res.data;
                  if(data.code === 200) {
                this.grazingSpaceOverview=data.result
                    } else {
                    // this.$message.error(data.message);
                }
            })
        },
        // 养殖信息查询列表
        getbreedList(){
        this.$http({
                url:'screenapp-service/screenLiveStock/count',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    "farmerId": this.basicsInfo.farmerId
                },
            }).then(res => {
                const data = res.data
                if(data.code==200){
                    this.breedList=data.result
                }
            })
        },
           // 存栏活畜品种分类查询
        getVarietiesList(){
        this.$http({
                url:'screenapp-service/screenLiveStock/assortment',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    "farmerId": this.basicsInfo.farmerId
                },
            }).then(res => {
                const data = res.data
                if(data.code==200){
                     data.result.forEach(item=>{     
                        this.kindTypeDis.push({
                               value:item.categoryQuantity,
                            name:item.categoryName
                        })     
                     })
                }
                   this.rangChart({
                      dom: 'chartRang2',
                      data: this.kindTypeDis
        })
            })
        },
        getDeviceList() {
            this.$http({
                // url: 'ffsapp-service/pasture/selectPastureVideo',
                url: 'https://gateway.east-mind.com/ffsapp-service/pasture/selectPastureVideo',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    // "userPhone": this.dataInfo.basicInfo.phone
                    "pastureId":"1590142441544728577",
                    "userPhone":"18247906555"
                    // "userPhone": this.basicsInfo.phone
                },
            }).then(res => {
                // console.log(res,'监控');
                const data = res.data;
                if(res.data.code === 200) {
                    this.deviceList = data.result.list
                    if (this.deviceList.length > 0) {
                        this.currentDeviceInfo = this.deviceList[0]
                        if (this.currentDeviceInfo.deviceType == 2) {
                            this.getLiveVideoUrl()
                        } else if (this.currentDeviceInfo.deviceType == 1) {
                            this.getPasturePlayUrl()
                        } else {
                            this.getPlayUrl()
                        }
                    }
                } else {
                    this.$message.error(data);
                }
            })
        },
        getLiveVideoUrl() {
            this.$http({
                url: 'https://gateway.east-mind.com/ffsapp-service/pasture/getLiveVideoUrl',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    deviceCode: this.currentDeviceInfo.deviceCode,
                    ezvizId: this.currentDeviceInfo.ezvizId,
                    channelCode: this.currentDeviceInfo.channelCode
                },
            }).then(res => {
                const data = res.data;
                if (data.code === 200) {
                    if(data.result.code === 200) {
                        this.flv_destroy()
                        this.playerVideo(data.result.data)
                    } else {
                        this.$message.error(data.result.message);
                    }
                } else {
                    // this.$message.error(data.message);
                }
            })
        },
        getPlayUrl() {
            let params = {
                    deviceCode: this.currentDeviceInfo.deviceCode,
                    channelCode: this.currentDeviceInfo.channelCode
                }
            if (this.currentDeviceInfo.deviceType == 3) {
                params.ezvizId = this.currentDeviceInfo.ezvizId;
            }
             
            this.$http({
                url: 'https://gateway.east-mind.com/ffsapp-service/ezviz/getPlayUrl',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    deviceCode: this.currentDeviceInfo.deviceCode,
                    channelCode: this.currentDeviceInfo.channelCode, 
                    ezvizId: this.currentDeviceInfo.ezvizId
                },
            }).then(res => {
                const data = res.data;
                if (data.code === 200) {
                    this.setCameras(data.result)
                } else {
                    // this.$message.error(data.message);
                }
            })
        },
        getPasturePlayUrl() {
            this.$http({
                url: 'https://gateway.east-mind.com/ffsapp-service/pasture/getPlayUrl',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    deviceCode: this.currentDeviceInfo.deviceCode,
                    channelCode: this.currentDeviceInfo.channelCode   
                },
            }).then(res => {
                const data = res.data;
                if (data.code === 200) {
                    this.flv_destroy()
                    this.playerVideo(data.result.flv)
                } else {
                    // this.$message.error(data.message);
                }
            })
        },
        
        goBack() {
            this.$router.go(-1)
        },
        detail(row) {
            this.$refs.NetworkModel.showModel(row)
        },
        selectLive(command) {
            // console.log(command, 'command')
            this.currentDeviceInfo = command
            if (this.currentDeviceInfo.deviceType == 2) {
                this.getLiveVideoUrl()
            } else if (this.currentDeviceInfo.deviceType == 1) {
                this.getPasturePlayUrl()
            } else {
                this.getPlayUrl()
            }
        },
        tableRowClassName({row, rowIndex}) {
            console.log(row)
            if (rowIndex % 2 == 1) {
                return 'row_bg'; 
            }
            return '';
        },
        rowClick(row) {
            this.enclosureList(row)
            // this.path = row.interspaceOverview.JsonDataLine
            // this.anType = row.interspaceOverview.JsonDataLine[0].type
            // this.infoMap(row.interspaceOverview.JsonDataRail)
        },
        rangChart(data) {
            // console.log(data,'data');
             const totalArr=data.data.map(item=>{
               return item.value
            })
            var totalNum=0
            totalArr.forEach(item=>{
                totalNum=totalNum+item
            })
            var myChart = this.$echarts.init(document.getElementById(data.dom));
            var option = {
                // color: ['#0EDAE2', '#5D2CFE', '#E7C660', '#2C76FE'],
                color: ['#5D2CFE', '#2C76FE', '#2C76FE', '#00FFFF'],

                title:{
                    show:true,
                    left:'40%',
                    top:'47%',
                    text :'共'+totalNum+'头',
                    textStyle:{
                       color:'#2C75FD',
                       fontWeight: 500,
                       fontSize:24
                    },
                },
                grid: {
                    // left: '10%',
                    height: '100px',
                },
                 tooltip: {
                    trigger: 'item',
                    axisPointer: {
                        type: 'shadow',
                    },
                    // backgroundColor: 'rgba(11, 15, 56, 1)',
                    // borderColor: 'rgba(18, 36, 132, 1)',
                    // borderWidth: 2,
                    // textStyle: {
                    //     color: '#fff',
                    // },
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    borderColor: '#292929',
                    borderWidth: 1,
                    textStyle: {
                        color: '#050F37',
                    },
                },
                legend:{
                    // left:'1%',
                    bottom:'3%',
                    icon:'circle',
                    textStyle:{
                        color : '#6FB6FF',
                        fontWeight: 400,
                        fontFamily: 'HarmonyOS Sans SC-Regular, HarmonyOS Sans SC'
                    }
                    // left:'10%'
                },
                series: [
                    {
                        type: 'pie',
                        radius: ['40%', '70%'],
                        // avoidLabelOverlap: false,
                        label: {
                            show: true,
                            position: 'inner',
                            color: '#FFFFFF',
                            // formatter: ' {b} {d}% \n\n',
                            formatter: ' {d}% ',
                            // padding: [0, -90],
                            alignTo: 'labelLine'
                        },
                        // labelLine: {
                        //     show: true,
                        //     length: 5,
                        //     length2: 100,
                        //     lineStyle: {
                        //         color: '#73c0de',
                        //     }
                        // },
                        data: data.data
                    }
                ]
            };
            myChart.setOption(option)
            window.addEventListener('resize', () => {
                myChart.resize()
            })
        },
        setCameras(item) {
            const _this = this
            if (_this.decoder && _this.decoder.stop) {
                _this.decoder.stop()
                _this.decoder = {}
                _this.camerasListItem = {}
                document.getElementById('myPlayer').innerHTML = ''
            }
            const w = this.$refs.device_box.offsetWidth
            const h = this.$refs.device_box.offsetHeight
            console.log(w, h)
            this.$nextTick(() => {
                document.getElementById('myPlayer').innerHTML = ''
                _this.camerasListItem = item
                _this.decoder = new this.$EZUIKit.EZUIKitPlayer({
                    id: 'myPlayer',
                    url: _this.camerasListItem.url,
                    accessToken: _this.camerasListItem.accessToken,
                    autoplay: true,
                    decoderPath: '/ezuikit',
                    width: w,
                    height: h,
                    splitBasis: 1,
                })
            })
        },
        playerVideo(url) {
            if (flvjs.isSupported()) {
                this.$nextTick(() => {
                    var videoElement = document.getElementById("myVideo");
                    this.flvPlayer = flvjs.createPlayer({
                        type: "flv",
                        url: url,
                        isLive: true,
                        hasAudio: false,
                        hasVideo: true,
                        withCredentials: false,
                        autoplay: false,
                        cors: true,
                    });
                    this.flvPlayer.attachMediaElement(videoElement);
                    this.flvPlayer.load();
                    this.flvPlayer.play();
                });
            } else {
                this.$message({
                    type: "warning",
                    message: "加载失败",
                });
            }
        },
        flv_destroy() {
            if (this.flvPlayer) {
                this.flvPlayer.pause();
                this.flvPlayer.unload();
                this.flvPlayer.detachMediaElement();
                this.flvPlayer.destroy();
                this.flvPlayer = null;
            }
        },
        infoMap(data) {
            this.map = new BMap.Map('map')
            // 大牛轨迹
            //创建地图
            var array = new Array()
            data.forEach(function(item,) {
                array.push(new BMap.Point(+item.longs, item.lat))
            })
            console.log(array,'niu')
            this.polygon2 = new BMap.Polygon(array, {
                strokeColor: '#f50704',
                fillColor: '#cfcfcf',
                strokeWeight: 3,
                strokeOpacity: 0,
                fillOpacity: 0,
            })
            // 设置中心点
            var point = new BMap.Point(array[0].lng, array[0].lat,{ mapType: BMAP_SATELLITE_MAP }) // 创建点坐标
            this.point1 = new BMap.Point(array[0].lng, array[0].lat, { mapType: BMAP_SATELLITE_MAP }) // 创建点坐标(接口数据替换)
            // 初始化地图,设置中心点坐标和地图级别
            this.map.centerAndZoom(point, 14)
            // this.map.setMapType(BMAP_HYBRID_MAP);
            this.map.setMapType(BMAP_NORMAL_MAP);

            var myDate = new Date()
            // 获取当前分钟
            var min = myDate.getMinutes()
            myDate.setMinutes(min - 5)
            var opts = {
                position: this.point1, // 指定文本标注所在的地理位置
                offset: new BMap.Size(0, -50), //设置文本偏移量
            }
            var label = new BMap.Label(myDate.toLocaleString(), opts) // 创建文本标注对象
            label.setStyle({
                color: 'red',
                fontSize: '12px',
                height: '20px',
                lineHeight: '20px',
                fontFamily: '微软雅黑',
                border: 'none',
                //background:'rgba(255,255,255,0)'
            })
            var marker = new BMap.Marker(new BMap.Point(array[0].lng, array[0].lat)) // (接口数据替换)
            marker.setAnimation(BMAP_ANIMATION_BOUNCE)
            this.initialize()
        },


        //创建标注点并添加到地图中
        addMarker(points) {
            //循环建立标注点
            for (var i = 0, pointsLen = points.length; i < pointsLen; i++) {
            var marker = new BMap.Marker(points[i]) //将点转化成标注点
            //添加监听事件
            ;(function() {
                var thePoint = points[i]
                marker.addEventListener('click', function() {
                    // showInfo(this, thePoint)
                    console.log(thePoint)
                })
            })()
            }
        },

        initialize() {
            // alert("点击标注点可以显示是否在区域内");
            // 开启百度地图API功能
            this.map.addControl(new BMap.NavigationControl()) // 添加平移缩放控件
            this.map.addControl(new BMap.ScaleControl()) // 添加比例尺控件
            this.map.addControl(new BMap.OverviewMapControl()) //添加缩略地图控件
            this.map.enableScrollWheelZoom() //启用滚轮放大缩小
            this.map.addControl(new BMap.MapTypeControl()) //添加地图类型控件
            this.addMarker(this.point1)
            this.map.addOverlay(this.polygon2)

            // map1.addControl(new BMap.NavigationControl()) // 添加平移缩放控件
            // map1.addControl(new BMap.ScaleControl()) // 添加比例尺控件
            // map1.addControl(new BMap.OverviewMapControl()) //添加缩略地图控件
            // map1.enableScrollWheelZoom() //启用滚轮放大缩小
            // map1.addControl(new BMap.MapTypeControl()) //添加地图类型控件

            // var point = new BMap.Point(111.709858,40.790287); // 创建点坐标
            // map.centerAndZoom(point, 12); // 初始化地图,设置中心点坐标和地图级别。
            this.pointStart()
            this.addMarker1(new BMap.Point(+this.path[0].longs, +this.path[0].lat), '起点', this.map)
        },
        addMarker1(point, name, mapInit) {
            if (name == '起点') {
            // var myIcon = new BMap.Icon(new BMap.Size(45, 45), {
            //     anchor: new BMap.Size(20, 45),
            // })
            var marker = new BMap.Marker(point); // 创建标注

            mapInit.addOverlay(marker);               // 将标注添加到地图中
            marker.setAnimation(BMAP_ANIMATION_BOUNCE); //跳动的动画
            }
        },
        pointStart(){
            var mapIcon = ''
            if (this.anType == 0) {
                mapIcon = require('../../assets/niu.jpg')
            } else {
                mapIcon = require('../../assets/sheep.jpg')
            }


            // var carMk //先将终点坐标展示的mark对象定义
            var PointArr = this.path
            this.myIcon2 = new BMap.Icon(mapIcon, new BMap.Size(65, 65), {
                anchor: new BMap.Size(30, 30),
            }) //初始化终点坐标图标
            var temporary = []
            var i = 0
            var interval = setInterval(() => {
                if (i >= PointArr.length - 1) {
                clearInterval(interval)
                return false
                }
                i = i + 1
                temporary.push(PointArr[i])
                this.drowLine(this.map, temporary) //画线调用
            }, 500)
        },
        drowLine(map, temporary) {
            if (temporary && temporary.length > 1) {
            //判断数值为两个点时开始进行绘制
            for (var i = 0; i < temporary.length - 1; i++) {
                var polyline22 = new BMap.Polyline([new BMap.Point(+temporary[i].longs, temporary[i].lat), new BMap.Point(+temporary[i + 1].longs, temporary[i + 1].lat)], {
                    strokeColor: 'green',
                    strokeWeight: 7,
                    strokeOpacity: 1,
                }) //创建折线
                map.addOverlay(polyline22)
                this.addMarkerEnd(new BMap.Point(+temporary[i + 1].longs, temporary[i + 1].lat), '终点', map, temporary[i + 1]) //添加图标
            }
            }
        },
        addMarkerEnd(point, name, mapInit, trackUnit) {
            if (name == '终点') {
            if (this.carMk) {
                //先判断第一次进来的时候这个值有没有定义，有的话就清除掉上一次的。然后在进行画图标。第一次进来时候没有定义也就不走这块，直接进行画图标
                mapInit.removeOverlay(this.carMk)
            }
            this.carMk = new BMap.Marker(point, { icon: this.myIcon2 }) // 创建标注
            this.carMk.setRotation(trackUnit.route) //trackUnit.route
            mapInit.addOverlay(this.carMk) // 将标注添加到地图中
                this.carMk.setAnimation(BMAP_ANIMATION_BOUNCE) //跳动的动画
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.bank_title {
    position: relative;

    .gobcak {
        position: absolute;
        // z-index: 999;
        bottom: -0.15rem;
        left: 0.16rem;
        font-size: 0.18rem;
        font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
        font-weight: 400;
        color: #FFFFFF;
        display: flex;
        align-items: center;
        cursor: pointer;

        i {
            font-size: 0.3rem;
            color: #fff;
            margin-left: 0.1rem;
        }
    }
}

.content {
    margin-top: 0.2rem;
    padding: 0 0.24rem;
    display: flex;

    .l {
        width: 6.25rem;
        height: 12rem;
        background: rgba(38, 103, 224, 0.0784);

        .user_info {
            padding: 0.05rem 0.5rem;
            border-right: 0;
            padding-bottom: 0.3rem;

            p {
                display: flex;
                font-size: 0.18rem;
                font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
                font-weight: 400;
                color: rgba(255, 255, 255, 0.5);
                margin-top: 0.26rem;

                label {
                    min-width: 1.1rem;
                }

                span {
                    color: #FFFFFF;
                }
            }
        }

        .chart_title {
            padding-left: 0.51rem;
            font-size: 0.2rem;
            font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
            font-weight: 400;
            color: #FAFAFA;
            margin-top: 0.56rem;
        }

        // .mt-sm {
        //     margin-top: 0.3rem;
        // }
        .mt-sm {
            margin-top: 0.5rem;
        }

        .rang_box {
            display: flex;
            justify-content: center;
            align-items: center;

            // .chart_rang {
            //     width: 4.8rem;
            //     height: 2.5rem;
            //     margin-top: 0.3rem;
            // }
            .chart_rang {
                width: 5.5rem;
                height: 5rem;
                margin: auto;
                // margin-top: 0.3rem;
            }
        }
    }

    .c {
        width: 10.5rem;
        height: 12rem;
        background: rgba(38, 103, 223, 0.08);
        margin-left: 0.25rem;

        .table {
            height: 10.5rem;
            padding: 0 0.25rem;

            .row_bg {
                background: rgba(255, 255, 255, 0.03);
            }
        }

        .operation {
            cursor: pointer;
        }

        .pagination {
            text-align: right;
            margin-top: 0.1rem;
        }
    }

    .r {
        width: 6.25rem;
        height: 12rem;
        background: rgba(38, 103, 224, 0.0784);
        margin-left: 0.25rem;

        .device_main {
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .device_box {
            width: 5.75rem;
            height: 4.63rem;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .space_data {
            display: flex;
            flex-wrap: wrap;
            margin-bottom: 0.38rem;
            padding-left: 0.25rem;

            .space_data_item {
                width: 50%;
                display: flex;
                align-items: center;
                font-size: 0.18rem;
                font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
                font-weight: 400;
                color: #FFFFFF;
                margin-top: 0.31rem;
                padding-left: 0.4rem;

                img {
                    width: 0.38rem;
                    height: 0.38rem;
                    margin-right: 0.16rem;
                }
            }
        }

        .map_box {
            width: 100%;
            display: flex;
            justify-content: center;
        }

        .map_main {
            width: 5.75rem;
            height: 3.75rem;
        }
    }

    .subtitle {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 0.24rem;
        margin: 0.19rem;

        .subtitle_txt {
            width: 3rem;
            height: 0.38rem;
            line-height: 0.38rem;
            padding-left: 0.23rem;
            font-size: 0.2rem;
            font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
            font-weight: 400;
            color: #FAFAFA;
            background-image: url("../../assets/title_bg_001.png");
            background-size: 100% 100%;
        }

        .tab_box {
            display: flex;

            .tab_item {
                font-size: 0.12rem;
                font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
                font-weight: 400;
                color: #FFFFFF;
                background: rgba(255, 255, 255, 0.0902);
                padding: 0.05rem 0.08rem;
                box-sizing: border-box;
                margin: 0.06rem;
                cursor: pointer;
            }

            .active {
                background: #286AE7;
            }
        }

        .el-dropdown-link {
            background: transparent;
            padding: 0.05rem 0.19rem;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.6);
        }
    }

    .total_data {
        display: flex;
        margin-top: 0.3rem;

        .total_data_item {
            display: flex;
            margin-left: 0.39rem;
            flex: 1;

            img {
                width: 0.68rem;
                height: 0.67rem;
            }

            div {
                display: flex;
                flex-direction: column;
                margin-left: 0.2rem;

                label {
                    font-size: 0.18rem;
                    font-weight: 400;
                    color: #D8DFFE;
                }

                span {
                    font-size: 0.43rem;
                    font-family: HarmonyOS Sans SC-Bold, HarmonyOS Sans SC;
                    font-weight: bold;
                    color: #FFBB00;
                    margin-top: 0.2rem;

                    i {
                        font-size: 0.18rem;
                        color: #FFFFFF;
                        font-style: normal;
                    }
                }

                .num {
                    display: flex;
                    flex-direction: row;
                    margin: 0;

                    .ratio {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        color: #00FFFF;
                        margin-top: 0.16rem;
                        margin-left: 0.4rem;

                        label {
                            font-size: 0.18rem;
                            color: #00FFFF;
                        }

                        span {
                            font-size: 0.18rem;
                            color: #00FFFF;
                            margin: 0 0.1rem;
                        }

                        img {
                            width: 0.3rem;
                            height: 0.3rem;
                        }
                    }
                }
            }
        }
    }
}
</style>

<style lang="scss">
.user_info {

    .el-table td.el-table__cell,
    .el-table th.el-table__cell.is-leaf {
        border: none;
        padding: 0;
    }

    /*最外层透明*/
    .el-table,
    .el-table__expanded-cell {
        background-color: transparent;
    }

    /* 表格内背景颜色 */
    .el-table tr {
        background: rgba(38, 103, 224, 0.08);
    }

    .el-table th {
        color: #f6f6f7;
        /* 字体颜色 */
        font-size: 0.18rem;
        background: rgba(38, 103, 224, 0.08) !important;
        /* 背景透明 */
        border: 0;
        height: 0.56rem;
        ;
        line-height: 0.56rem;
        ;
    }

    .el-table tr+.row_bg {
        background: rgba(255, 255, 255, 0.03);
    }

    .el-table tr,
    .el-table td {
        color: rgba(255, 255, 255, 0.5);
        font-size: 0.18rem;
        /* background-color: transparent ; */
        border: 0;
        height: 0.56rem;
        ;
        line-height: 0.56rem;
        ;
    }

    .el-table__body tr.current-row>td.el-table__cell,
    .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
        background: rgba(255, 255, 255, 0.1) !important;
        color: #FFFFFF;
    }

    .el-table::before {
        left: 0;
        bottom: 0;
        width: 100%;
        height: 0px;
    }

    /* 设置滚动条样式 */
    /*表格滚动条和字体颜色*/
    .table .el-table {
        border-bottom: 0;
        color: hsla(0, 0%, 100%, 0.6);
        padding-right: 0.0625rem;
        margin: 0
    }


    /* 设置滚动条的样式 */
    ::-webkit-scrollbar {
        width: 5px;
        /*滚动条粗细*/
    }

    /* 滚动槽 */
    ::-webkit-scrollbar-track {
        -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
        border-radius: 10px;
    }

    /* 滚动条滑块 */
    ::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background: rgba(0, 0, 0, 0.3);
        -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
    }

    .el-tabs__active-bar {
        height: 0px;
    }

    .el-tabs__nav-wrap::after {
        height: 0px;
    }

    .el-tabs__nav {
        padding-left: 0.2rem;
    }

    .el-table__header {
        width: 606px;
    }

    ::v-deep .goback {
        display: flex;
        align-items: center;
    }

    .el-pagination .btn-next,
    .el-pagination .btn-prev,
    .el-pagination button:disabled,
    .el-pager li {
        background: transparent;
        color: #ccc;
    }

    video::-webkit-media-controls-fullscreen-button {
        display: none;
    }

    video::-webkit-media-controls-play-button {
        display: none;
    }

    video::-webkit-media-controls-timeline {
        display: none;
    }

    video::-webkit-media-controls-current-time-display {
        display: none;
    }

    video::-webkit-media-controls-time-remaining-display {
        display: none;
    }

    video::-webkit-media-controls-mute-button {
        display: none;
    }

    video::-webkit-media-controls-toggle-closed-captions-button {
        display: none;
    }

    video::-webkit-media-controls-enclosure {
        display: none;
    }

    video::-webkit-media-controls-volume-slider {
        display: none;
    }
}
</style>